module.exports = "/images/logo_pergamum_vertical.png?8ca63699f4da66c1ef72fd06add5ddd7";